import { GATracking } from "../../utils/webtracking";
import HttpClient from "../client/httpclient";
import Loader from "../loading/loader";
import 'regenerator-runtime/runtime';

class AutoComplete {
    constructor(DOMelement) {
        try {
            this.EnterKeyCode = 13;
            this.el = DOMelement;
            this.input = this.el.querySelector(".sd-input");
            this.button = this.el.querySelector("button");
            this.loaderEl = document.querySelector(".sd-searchbar > .sd-loading");
            this.loader = new Loader(this.loaderEl);

            this.searchResults = this.searchResults.bind(this);
            this.UpdateEventTracking = this.UpdateEventTracking.bind(this);

            this.searchButtonEl = document.getElementById("sd-search-open-desktop");
            this.input.addEventListener("keyup", this.searchResults);
            this.debouncedHandleKeyupEvent = this.debounce(this.handleKeyupEvent.bind(this), 600);
            this.input.addEventListener('keyup', this.debouncedHandleKeyupEvent);

            this.button.addEventListener("click", this.searchResults);
            this.searchButtonEl.addEventListener("click", this._addResults);

            this.url = this.input.getAttribute("data-action");
            this.method = "GET";
            if (process.env.NODE_ENV === "development") {
                this.url = "/src/api/onsite-autocomplete-empty.json";
            }

            this.dataLocation = this.input.getAttribute("data-location");
            this.noResultFlag = 0;
            this.messageEl = null;
            this.noResultContent = "";
            this.noPropTourMessage = "";
            this.spellCheckContent = "";

        } catch (error) {
            console.log(error);
        }
    }

    get addResults() {
        return this._addResults;
    }
    set addResults(value) {
        this._addResults = value;
        this.debouncedHandleKeyupEvent();
    }

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Debounce function to limit the rate at which a function can fire
    debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    // Function to handle the keyup event
    async handleKeyupEvent(event) {
        if ((event.keyCode != this.EnterKeyCode) && (event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40)) {
            if(this.messageEl != null){
                this.messageEl.innerHTML = "";
                this.spellCheckContent = "";
                this.noPropTourMessage = "";
                this.noResultContent = ""
            }
            await this.delay(700); // Wait for 700ms
            await this._addResults();  // Call the API
        }
    }

    searchResults(event) {
        if (this.input.value) {
            if (event.type === 'click' || event.keyCode === this.EnterKeyCode) {
                if (this.el.getAttribute('data-ga') === "bannerSearch") {
                    GATracking.customObjectEventTracking('header_click', 'header', 'search', { 'event_label': this.input.value, 'page_title': document.title });
                }
                if (this.el.getAttribute('data-ga') === "navbarSearch") {
                    GATracking.customObjectEventTracking('header_click', 'header', 'search', { 'event_label': this.input.value, 'page_title': document.title });
                }
                window.location.href = this.dataLocation + '?q=' + this.input.value.split(' ').join('+');
            }
        }
    }

    _addResults = async (event) => {
        this.input.focus();
        if (this.input.value.length > 2) {
            this.FetchSearchPageResults();
        }
    };

    FetchSearchPageResults = async () => {
        if (this.loader) {
            this.loader.show();
        }
        var resultsData = await HttpClient.AsyncGetRequest(this.url + "?q=" + this.input.value, this.method)
            .then(result => {
                if (this.loader) {
                    this.loader.hide();
                }
                return JSON.parse(result);
            })
            .catch(error => {
                if (this.loader) {
                    this.loader.hide();
                }
                console.error(error);
            });

        var tabsContainer = document.getElementById('tabs-container'),
            tabContentContainer = document.getElementById("tab-content-container"),
            defaultSearchOptions = document.getElementById('default-search-options'),

        // Calling the transform function
        resultsData = this.transformData(resultsData);
        if (resultsData == "") {
            tabsContainer.style.display = "none";
            tabContentContainer.style.display = "none";
            defaultSearchOptions.classList.remove("hideDefaultSearch");
        };
        if (this.noPropTourMessage) {
            if(this.messageEl === null){
                this.messageEl = document.createElement('div');
                this.messageEl.classList.add('search-extra-message');
                this.messageEl.innerHTML = this.noPropTourMessage;
                defaultSearchOptions.insertAdjacentElement('beforebegin', this.messageEl);
            }else{
                this.messageEl.innerHTML = this.noPropTourMessage;
            }
            tabContentContainer.style.display = "none";
            tabsContainer.style.display = "none";
            defaultSearchOptions.classList.remove("hideDefaultSearch");
        }
        if (this.noResultContent) {
            if(this.messageEl === null){
                this.messageEl = document.createElement('div');
                this.messageEl.classList.add('search-extra-message');
                this.messageEl.innerHTML = this.noResultContent;
                defaultSearchOptions.insertAdjacentElement('beforebegin', this.messageEl);
            }else{
                this.messageEl.innerHTML = this.noResultContent;
            }
            tabContentContainer.style.display = "none";
            tabsContainer.style.display = "none";
            defaultSearchOptions.classList.remove("hideDefaultSearch");
        }
        if (resultsData != "" && resultsData !== undefined) {
            tabsContainer.style.display = "flex";
            tabsContainer.innerHTML = "";
            tabContentContainer.style.display = "block";
            tabContentContainer.innerHTML = ""
            defaultSearchOptions.classList.add("hideDefaultSearch");
            if(this.spellCheckContent){
                if(this.messageEl === null){
                    this.messageEl = document.createElement('div');
                    this.messageEl.classList.add('search-extra-message');
                    this.messageEl.innerHTML = this.spellCheckContent;
                    defaultSearchOptions.insertAdjacentElement('beforebegin', this.messageEl);
                }else{
                    this.messageEl.innerHTML = this.spellCheckContent;
                }
            }

            resultsData.forEach(function (tab, index) {

                if (tab.resultsCount != 0) {
                    var tabButton = document.createElement('div');
                    tabButton.className = 'tab-button';
                    tabButton.textContent = tab.title + ' (' + tab.resultsCount + ')';
                    tabButton.onclick = function () {
                        showTab(tab.id, index);
                    };
                    tabsContainer.appendChild(tabButton);
                    var handleImgError = "javascript:this.src='../../static/assets/images/default-image-on-search.PNG';this.alt='image not found';this.onerror=null;"
                    var tabContent = document.createElement('div');
                    tabContent.className = 'tab';
                    tabContent.id = tab.id;
                    tabContent.setAttribute('data-cs-override-id', tab.id); //Dynamic IDs for ContentSquare SDEWW-781

                    if (tab.title == "Tours") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container">`

                        for (let i = 0; i < tab.tourResults.length; i++) {
                            tabData += `<div class="onsite-card">
                                        <a href="${tab.tourResults[i].itemUrl != null ? tab.tourResults[i].itemUrl : '/#'}">
                                        <div class="onsite-card-content">`

                            if (tab.tourResults[i].bagde == true) {
                                tabData += '<div class="sd-ribbon sd-ribbon-choice"></div>'
                            }

                            tabData += `<div class="onsite-card-img">`

                            tabData += `<img src="${tab.tourResults[i].imageurl}" alt="${tab.tourResults[i].location}" onerror="${handleImgError}"/>
                    
                            </div>
                            <div class="onsite-card-text">
                                <h2 class="onsite-card-title tours">${tab.tourResults[i].title}</h2>
                                <p class="onsite-tours-nights">${tab.tourResults[i].nights} Nights</p>`
                                if (tab.tourResults[i].location != null) {
                                    tabData += `<p class="onsite-card-subtitle">${tab.tourResults[i].location}</p>`
                                }
                                tabData += `</div>
                            </div>
                            </a>
                            </div> `
                        }
                        tabData += ` </div>
                            <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;

                        tabContent.innerHTML = `${tabData}`;
                    }

                    if (tab.title == "Hotels") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container"> `

                        for (let i = 0; i < tab.hotelResults.length; i++) {
                            tabData += `<div class="onsite-card">
                                        <a href="${tab.hotelResults[i].itemUrl != null ? tab.hotelResults[i].itemUrl : '/#'}">
                                        <div class="onsite-card-content">`

                            if (tab.hotelResults[i].bagde == true) {
                                tabData += '<div class="sd-ribbon sd-ribbon-choice"></div>'
                            }

                            tabData += `<div class="onsite-card-img">`

                            tabData += `<img src="${tab.hotelResults[i].imageurl}" alt="${tab.hotelResults[i].location}" onerror="${handleImgError}"/>
                            </div>
                            <div class="onsite-card-text">
                                <h2 class="onsite-card-title hotels">${tab.hotelResults[i].title}</h2>`
                                    if (tab.hotelResults[i].location != null) {
                                        tabData += `<p class="onsite-card-subtitle">${tab.hotelResults[i].location}</p>`
                                    }
                                    tabData += `</div>
                            </div>
                            </a>
                            </div>  `
                        }
                        tabData += ` </div>
                            <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;

                        tabContent.innerHTML = `${tabData}`;
                    }
                    if (tab.title == "Offers") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container">`
                                        
                        if (tab.offerResults.length > 0) {
                            for (let i = 0; i < tab.offerResults.length; i++) {
                                tabData += `<div class="onsite-card">
                                            <a href="${tab.offerResults[i].itemUrl != null ? tab.offerResults[i].itemUrl : '/#'}">
                                            <div class="onsite-card-content">`
                                
                                tabData += `<div class="onsite-card-img">`;
                                tabData += `<img src="${tab.offerResults[i].imageurl}" alt="${tab.offerResults[i].area}" onerror="${handleImgError}"/>
                                </div>
                                <div class="onsite-card-text">
                                    <h2 class="onsite-card-title">${tab.offerResults[i].title}</h2>`
                                        if (tab.offerResults[i].area != null) {
                                            tabData += `<p class="onsite-card-subtitle offers">${tab.offerResults[i].area}</p>`
                                        }
                                        tabData += `<ul class="onsite-offers-list">`;
                                        for (let j of tab.offerResults[i].offerTitle) {
                                            var splitOffer = j.split("-");
                                            tabData += `<li class="onsite-offers-item">
                                                <div>${splitOffer[splitOffer.length - 1].trim()}</div>
                                            </li>`
                                        }
                                        tabData += `</ul>                        
                                </div>
                                </div>
                                </a>
                                </div> `
                            }
                        }
                        tabData += `</div>
                            <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;

                        tabContent.innerHTML = `${tabData}`;
                    }

                    if (tab.title == "Things to Do" || tab.title == "Things To Do") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container">`

                        for (let i = 0; i < tab.thingsToDoResults.length; i++) {
                            tabData += `<div class="onsite-card">
                                        <a href="${tab.thingsToDoResults[i].itemUrl != null ? tab.thingsToDoResults[i].itemUrl : '/#'}">
                                        <div class="onsite-card-content">`

                            if (tab.thingsToDoResults[i].bagde == true) {
                                tabData += '<div class="sd-ribbon sd-ribbon-choice"></div>'
                            }

                            tabData += `<div class="onsite-card-img">`

                            tabData += `<img src="${tab.thingsToDoResults[i].imageurl}" alt="${tab.thingsToDoResults[i].location}" onerror="${handleImgError}"/>
                            </div>
                            <div class="onsite-card-text">
                                <h2 class="onsite-card-title experiences">${tab.thingsToDoResults[i].title}</h2>`
                                    if (tab.thingsToDoResults[i].location != null) {
                                        tabData += `<p class="onsite-card-subtitle">${tab.thingsToDoResults[i].location}</p>`
                                    }
                                    tabData += `</div>
                            </div>
                            </a>
                            </div> `
                        }
                        tabData += `</div>
                            <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;
                        tabContent.innerHTML = `${tabData}`;
                    }

                    if (tab.title == "Inspiration") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container">`

                        for (let i = 0; i < tab.inspirationResults.length; i++) {
                            tabData += `<div class="onsite-card">
                                        <a href="${tab.inspirationResults[i].itemUrl != null ? tab.inspirationResults[i].itemUrl : '/#'}">
                                        <div class="onsite-card-content">`

                            if (tab.inspirationResults[i].bagde == true) {
                                tabData += '<div class="sd-ribbon sd-ribbon-choice"></div>'
                            }

                            tabData += `<div class="onsite-card-img">`

                            tabData += `<img src="${tab.inspirationResults[i].imageurl}" alt="${tab.inspirationResults[i].title}" onerror="${handleImgError}"/>
                            </div>
                            <div class="onsite-card-text">
                                <h2 class="onsite-card-title inspiration">${tab.inspirationResults[i].title}</h2>`
                                    if (tab.inspirationResults[i].area != null) {
                                        tabData += `<p class="onsite-card-subtitle">${tab.inspirationResults[i].area}</p>`
                                    }
                                    if (tab.inspirationResults[i].publishDate != null && tab.inspirationResults[i].publishDate != "01 January 0001") {
                                        tabData += `<p class="onsite-card-subtitle">${tab.inspirationResults[i].publishDate}</p>`
                                    }
                                    tabData += `</div>
                            </div>
                            </a>
                            </div> `
                        }
                        tabData += `</div>
                            <div class="sd-view-results-button sd-button--primary"  id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;

                        tabContent.innerHTML = `${tabData}`;
                    }
                    if (tab.title == "Team") {
                        let tabData = `<div class="sd-results-container sd-autocomplete__results">
                                        <div class="onsite-card-container">`

                        for (let i = 0; i < tab.teamResults.length; i++) {
                            tabData += `<div class="onsite-card">
                                        <a href="${tab.teamResults[i].itemUrl != null ? tab.teamResults[i].itemUrl : '/#'}">
                                        <div class="onsite-card-content">`
                            if (tab.teamResults[i].bagde == true) {
                                tabData += '<div class="sd-ribbon sd-ribbon-choice"></div>'
                            }
                            tabData += `<div class="onsite-card-img">`
                            tabData += `<img src="${tab.teamResults[i].imageurl}" alt="${tab.teamResults[i].title}" onerror="${handleImgError}"/>
                            </div>
                            <div class="onsite-card-text">
                                <h2 class="onsite-card-title">${tab.teamResults[i].title}</h2>`
                                    if (tab.teamResults[i].teamExpert != null) {
                                        tabData += `<p class="onsite-card-subtitle" style="text-transform: capitalize;">${tab.teamResults[i].teamExpert}</p>`
                                    }
                                    tabData += `</div>
                                </div>
                            </a>
                            </div>  `
                        }
                        tabData += `</div>
                            <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                                <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a>
                            </div>
                        </div>`;

                        tabContent.innerHTML = `${tabData}`;
                    }

                    if (tab.title == "Destinations") {
                        let destinationContentData = `<div class="sd-results-container sd-autocomplete__results" style="top:auto">
                        <div class="sd-destination-items">
                            <ul class="sd-country">
                            <li class="sd-destinations-title">
                                <p>Countries</p>
                            </li>`

                        for (let i = 0; i < tab.countryResults.length; i++) {
                            destinationContentData += `<li class=" country-page">
                            <a href="${tab.countryResults[i].itemUrl}">${tab.countryResults[i].country != null ? tab.countryResults[i].country : tab.countryResults[i].title} </a >
                            </li>`
                        }

                        destinationContentData += ` </ul>
                        <ul class="sd-area">
                            <li class="sd-destinations-title">`;
                                if (tab.areaResults.length > 0) {
                                    destinationContentData += `<p>Areas</p>`
                                }
                            `</li>`
                            for (let i = 0; i < tab.areaResults.length; i++) {
                                destinationContentData += `
                                <li class=" country-page">
                                    <a href="${tab.areaResults[i].itemUrl}">${tab.areaResults[i].title} </a>
                                </li>`
                            }
                            destinationContentData += `</ul>
                        </div>
                        <div class="sd-view-results-button sd-button--primary" id="${tab.title}" data-value="${tab.filterId}">
                        <a href="${tab.viewAllResults}">VIEW ALL RESULTS</a></div>`
                        tabContent.innerHTML = `${destinationContentData}`;
                    }
                    tabContentContainer.appendChild(tabContent);
                }
            });
            showTab(resultsData[0].id, 0);
            this.AttachCardsToAnalytics();
            this.AttachViewAllButtonsToAnalytics();
        }

        function showTab(tabId, tabIndex) {
            var tabs = document.getElementsByClassName('tab');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].classList.remove('active-tab');
            }

            document.getElementById(tabId).classList.add('active-tab');

            var tabButtons = document.getElementsByClassName('tab-button');
            for (var i = 0; i < tabButtons.length; i++) {
                tabButtons[i].classList.remove('active-tab-button');
            }

            tabButtons[tabIndex].classList.add('active-tab-button');
        }
    }

    AttachViewAllButtonsToAnalytics() {
        var btnContainer = document.querySelector("#tab-content-container");

        var tabsCollection = btnContainer.querySelectorAll(".tab");
        tabsCollection.forEach(tab => {
            var tabParentBtn = tab.querySelector(".sd-view-results-button");
            var btnCategory = tabParentBtn.id;
            var tabBtn = tabParentBtn.querySelector("a");
            tabBtn.addEventListener("click", (event) => this.UpdateEventTracking(event, btnCategory));
        });
    }

    AttachCardsToAnalytics() {
        var cards = document.querySelectorAll('.onsite-card>a');

        cards.forEach(card => {
            card.addEventListener('click', (event) => this.UpdateEventTracking(event, "suggestion"));
        });
    }

    UpdateEventTracking(event, strBtnCategory) {
        event.preventDefault();
        var convertedTitle;

        if (strBtnCategory == "suggestion") {
            var targetItem = event.currentTarget;
            var targetContent = targetItem.querySelector(".onsite-card-content");
            var targetTitle = targetContent.querySelector(".onsite-card-text>.onsite-card-title").innerHTML;

            convertedTitle = this.ConvertStringToSuggestionName(targetTitle);
        } else {
            convertedTitle = strBtnCategory.replace(/\s+/g, '-') + "-View-All-Results";
        }

        //processing to get all the required fields/info
        GATracking.customObjectEventTracking('searchAutocomplete', 'header', 'search', { 'search_suggestion': convertedTitle, 'page_title': document.title });
        window.location.href = event.currentTarget.href;
    }

    ConvertStringToSuggestionName(input) {
        let selectedTabItem = document.querySelector('.active-tab-button').innerHTML;
        let selectedTabVal = selectedTabItem.replace(/\s*\(\d+\)/, '') + " - " + input;

        var result = selectedTabVal
            .replace("-", '')
            .replace(/,/g, '')
            .replace(/\s+/g, '-');

        return result;
    }

    // Transforming function
    transformData(originalData) {
        const transformedData = [];
        if (originalData[0].noPropTourMessage != null) {
            this.noPropTourMessage = originalData[0].noPropTourMessage;
            return;
        }
        this.spellCheckContent = (originalData[0].spellCheckMessage);
        originalData.forEach(item => {
            const tabs = Object.keys(item).filter(key => key.startsWith('filter'));
            this.noResultFlag = 0;
            this.noPropTourMessage = "";
            tabs.forEach((tab, index) => {
                const filter = item[tab];
                if (filter.resultsCount == 0) {
                    this.noResultFlag += 1;
                    this.noResultContent = "";

                    if (this.noResultFlag == 7) {
                        this.noResultContent = (originalData[0].notFoundMessage);
                    }
                    return;
                }
                const transformedTab = {
                    id: `tab${index}`,
                    title: filter.title,
                    resultsCount: filter.resultsCount,
                    filterId: filter.filterId
                };

                if (tab === 'filtersDestination') {
                    transformedTab.countryResults = filter.countryResults.map(country => ({
                        title: country.title,
                        itemUrl: country.itemUrl,
                        country: country.country,
                        area: country.area,
                        nights: country.nights,
                        imageurl: null
                    }));
                    transformedTab.areaResults = filter.areaResults.map(area => ({
                        title: area.title,
                        itemUrl: area.itemUrl,
                        country: area.country,
                        area: area.area,
                        nights: area.nights,
                        imageurl: null
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterTours') {
                    transformedTab.tourResults = filter.results.map(tour => ({
                        title: tour.title,
                        itemUrl: tour.itemUrl,
                        country: tour.country,
                        area: tour.area,
                        nights: tour.nights,
                        imageurl: tour.imageurl,
                        badge: tour.bagde || false,
                        location: tour.location

                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterHotels') {
                    transformedTab.hotelResults = filter.results.map(hotel => ({
                        title: hotel.title,
                        itemUrl: hotel.itemUrl,
                        country: hotel.country,
                        area: hotel.area,
                        nights: hotel.nights,
                        imageurl: hotel.imageurl,
                        location: hotel.location
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterOffer') {
                    transformedTab.offerResults = filter.results.map(offer => ({
                        title: offer.title,
                        itemUrl: offer.itemUrl,
                        country: offer.country,
                        area: offer.area,
                        nights: offer.nights,
                        imageurl: offer.imageurl,
                        offerTitle: offer.offerTitle
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterThingsToDo') {
                    transformedTab.thingsToDoResults = filter.results.map(thing => ({
                        title: thing.title,
                        itemUrl: thing.itemUrl,
                        country: thing.country,
                        area: thing.area,
                        nights: thing.nights,
                        imageurl: thing.imageurl,
                        location: thing.location
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterInspiration') {
                    transformedTab.inspirationResults = filter.results.map(inspiration => ({
                        title: inspiration.title,
                        itemUrl: inspiration.itemUrl,
                        country: inspiration.country,
                        area: inspiration.area,
                        nights: inspiration.nights,
                        imageurl: inspiration.imageurl,
                        publishDate: inspiration.publishDate
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                } else if (tab === 'filterTeam') {
                    transformedTab.teamResults = filter.results.map(team => ({
                        title: team.title,
                        itemUrl: team.itemUrl,
                        country: team.country,
                        area: team.area,
                        nights: team.nights,
                        imageurl: team.imageurl,
                        teamExpert: team.teamExpert
                    }));
                    transformedTab.viewAllResults = filter.viewAllResults;
                }
                transformedData.push(transformedTab);
            });
        });
        return transformedData;
    }
}


export default AutoComplete;